/** Захиалагчийн хүргэлтийн тайлбарын дээд урт (chef-api: orders.deliveryNote VARCHAR(500)). */
export const DELIVERY_NOTE_MAX_LENGTH = 500;

/** Очиж авах захиалгын хаягийн оронд харуулах бичиглэл. */
export const PICKUP_LABEL = 'Очиж авна';
